import qs from 'qs'
import { useCallback } from 'react'
import { useLocation } from 'react-router'

import { useSegment } from './useSegment'

/* Used to pass the anonymousId from the query string to the segment analytics */
/* It reads the anonymousId from the query string supposedly passed from another place */
/* Potential case: passed from billy.dk on signup redirection */
/* Therefore may actually not be used anymore */
export const useAnonymousId = () => {
  const { setAnonymousId: setSegmentAnonymousId } = useSegment()
  const location = useLocation()

  const searchParsed = qs.parse(location?.search || '', { ignoreQueryPrefix: true }) || {}
  const anonymousIdFromQuery = searchParsed.anonymousId

  const setAnonymousId = useCallback(
    (anonymousId?: string) => {
      const anonymousIdValue = anonymousId || anonymousIdFromQuery

      if (typeof anonymousIdValue === 'string') {
        setSegmentAnonymousId(anonymousIdValue)
      }
    },
    [anonymousIdFromQuery, setSegmentAnonymousId],
  )

  return { setAnonymousId }
}
